export const getTracking = state => state.tracking
export const getPush = state => getTracking(state).push
export const getType = state => getTracking(state).type
export const getMeta = state => getTracking(state).meta
